import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeProvider';
import HomePage from './pages/HomePage';
import TechPlaygroundPage from './pages/TechPlaygroundPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ResumeEditorPage from './pages/ResumeEditorPage';
import AdminRoute from './components/AdminRoute';
import { Toaster } from "@/components/ui/toaster";
import './App.css';

function App() {
  return (
    <ThemeProvider
      defaultTheme="dark"
      storageKey="vtech-navigator-theme"
      enableSystem={false}
    >
      <div className="min-h-screen bg-background text-foreground">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tech-playground" element={<TechPlaygroundPage />} />
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route 
            path="/admin-dashboard" 
            element={
              <AdminRoute>
                <AdminDashboardPage />
              </AdminRoute>
            } 
          />
          <Route path="/resume-editor/:resumeId" element={<ResumeEditorPage />} />
          <Route path="/resume-editor/new" element={<ResumeEditorPage />} />
        </Routes>

        {/* 👇 Make sure this is included once in your app */}
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
